// Mirrors the backend no-go trigger (virtualAppointments.nogos.ts): go back counts, a go resets.
export const NO_DM_LINK_HINT = 'Link the patient to Dental Monitoring first';

export const NOGOS_RULE_HINT = 'Consecutive no-gos, go back included; a go resets the count';

export function nogosUnavailableHint(dmLinked: boolean): string | undefined {
    return dmLinked ? undefined : NO_DM_LINK_HINT;
}

// How far a planned no-go VA is from opening: "2 to go", or "reached".
export function nogosProgressHint(nogos: number | null, nogoCount: number): string | null {
    if (nogos === null) return null;
    return nogoCount >= nogos ? 'reached' : `${nogos - nogoCount} to go`;
}
